__webpack_require__.p = "https://cdn.sheetgo.com/webapp/prod/prod.candidate.intergalactic-hamster-heroes-d/";